export default {
    qualityAssuranceModal: {
        isOpen: false,
        isLoading: false,
        editingId: null,
        data: {
            id: null,
            number: '',
            project: null,
            order: null,
            delivery: '',
            status: null,
            test_type: null,
            test_time: null,
            water_test_psf: null,
            water_test_allowable: 'No Leakage',
            water_test_results: null,
            air_test_psf: null,
            air_test_allowable: '0.15',
            air_test_results: null,
            visual_investigation_notes: '',
            passed: null,
            is_outside_view: true,
            test_result_comment: '',
            test_results: '',
            creator: null,
            created_at: null,
            updater: null,
            updated_at: null,
            completer: null,
            completed_at: null,
            canceler: null,
            canceled_at: null,
            canceled_reason: '',
            images: [],
            attachments: [],
            position_images: [],
            qr_code: null,
            position: null,
        },
        errors: {},
        autocomplete: {
            projectsSearchTerm: '',
            ordersSearchTerm: '',
            projects: [],
            orders: [],
            test_types: [],
            statuses: [],
        },
        actionWithReason: {
            isOpen: false,
            action: null,
            reason: '',
            errors: {},
        },
        qrCodeReaderIsOpened: false,
    },
    confirmation: {
        isOpen: false,
        title: '',
        text: '',
        accept: null,
        acceptText: null,
        cancel: null,
        cancelText: null,
    },
    qualityAssuranceList: {
        refreshList: false,
        filtersOpen: false,
        filterData: {
            test_types: [],
            statuses: [],
        },
        filters: {
            per_page: 10,
            filter: '',
            test_type: [],
            passed: [],
            status: [],
        },
    },
};
